import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import {
  ONLY_NUMBERS_RULE,
  PERSIAN_LATTER_RULE,
} from '@/common/components/base/input/textInput/textInput.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const AddDamagedOtherLegalForm = () => {
  return (
    <Box className={css({ marginTop: '2rem' })}>
      <TextInput
        label="نام"
        name="name"
        placeholder="نام را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />{' '}
      <Box>
        <MobileInput name="phone_number" />
      </Box>
      <TextInput
        label="شماره ثبت"
        name="owner_registration_number"
        placeholder="شماره ثبت را وارد کنید"
        rules={{ ...ONLY_NUMBERS_RULE }}
        optionalLabel
      />
      <TextInput
        label="کد اقتصادی"
        name="owner_economic_code"
        rules={{ ...ONLY_NUMBERS_RULE }}
        placeholder="کد اقتصادی را وارد کنید"
        optionalLabel
        noCharInput
      />
      <TextInput
        label="شناسه ملی"
        name="owner_identity_number"
        rules={{ ...ONLY_NUMBERS_RULE }}
        placeholder="شناسه ملی را وارد کنید"
        optionalLabel
        noCharInput
      />
    </Box>
  );
};

export default AddDamagedOtherLegalForm;
